export default "__VITE_PUBLIC_ASSET__f55a2c65__"